<template>
    <div class="lesson-manual">
        <design-2021-group-lesson-manual-nav-component
            v-if="lessons.length > 0"
            :lessons-in="lessons"
            :parent-in="groupIn"
            :selected-lesson-in="selectedLesson"
            :parent-type="'group'"
            @lesson-updated="updateLesson"
            @change-lesson="updateSelectedLesson">
        </design-2021-group-lesson-manual-nav-component>

        <design-2021-lesson-manual-lesson-overview-component
            v-if="lessonsIn.length > 0"
            @lesson-updated="updateLesson"
            :lesson-in="selectedLesson">
        </design-2021-lesson-manual-lesson-overview-component>
    </div>
</template>

<script>
export default {
    name: 'design-2021-group-lesson-manual-component',
    props: {
        groupIn: {
            type: Object,
        },
        lessonsIn: {
            type: Array,
        },
    },
    data() {
        return {
            lessons: this.lessonsIn,
            selectedLesson: this.lessonsIn.length ? this.lessonsIn[0] : null,
        };
    },

    methods: {
        updateSelectedLesson(lesson) {
            this.selectedLesson = this.lessons.find((lesson0) => lesson0.id === lesson.id);
        },

        updateLesson(lessonNew) {
            this.lessons = this.lessons.map((lessonOld) => {
                if (lessonOld.id === lessonNew.id) {
                    return lessonNew;
                }
                return lessonOld;
            });
            this.updateSelectedLesson(lessonNew);
        },
    },
};
</script>

<style scoped lang="scss">
.lesson-manual ::v-deep {
    display: grid;
    grid-template-columns: auto;
    grid-template-rows: repeat(2, auto);
    grid-gap: $grid-gutter-width 0;

    .lesson-manual-nav,
    .populate-data {
        grid-column: 1 / 2;
        grid-row: 1 / 2;
    }

    .lesson-overview {
        grid-column: 1 / 2;
        grid-row: 2 / 3;
    }

    .populate-data {
        grid-column: 1 / 3;
        grid-row: 1 / 2;

        .not-found {
            align-items: flex-start;
        }
    }
}

@media (min-width: map-get($grid-breakpoints, 'xl')) {
    .lesson-manual ::v-deep {
        grid-template-columns: minmax(375px, 450px) minmax(calc(100% - 415px), calc(100% - 480px));
        grid-template-rows: auto;
        grid-column-gap: $grid-gutter-width;

        .lesson-manual-nav {
            grid-column: 1 / 2;
            grid-row: 1 / 2;
        }

        .lesson-overview {
            grid-column: 2 / 3;
            grid-row: 1 / 2;
        }
    }
}

@media (min-width: map-get($grid-breakpoints, 'xxl')) {
    .lesson-manual ::v-deep {
        grid-template-columns: 450px calc(100% - 510px);
        grid-column-gap: map-get($grid-gutter-spacing, 'sixty');
    }
}
</style>
